export enum ChatScopes {
  CAN_VIEW = 'can_view_chat',
  CAN_CREATE_ONE_ON_ONE = 'can_create_one_on_one',
  CAN_CREATE_GROUP = 'can_create_group',
}
